import { Link } from 'react-router-dom';
import clsx from 'clsx';
import { buttonVariants } from '@playcastdotio/Shadcn';
import { invitationState } from '../../../api/stores/lobbyStores';
import { useState } from 'react';
import { useEffect } from 'react';
import { playerConnectionState } from '../../../api/stores/playerStores';

export const DisconnectedPlayer = () => {
  const [kickReason, setKickReason] = useState<string | null>(null);

  useEffect(() => {
    const listener = playerConnectionState.addListener((state) => {
      if (state.kickReason) setKickReason(state.kickReason);
    });
    if (playerConnectionState.currentState.kickReason) setKickReason(playerConnectionState.currentState.kickReason);
    return () => {
      playerConnectionState.removeListener(listener);
    };
  }, []);

  return (
    <div className='flex flex-col items-center justify-center gap-y-8'>
      <div className='grid-rows col-span-full mx-auto grid content-center justify-center gap-y-4 text-center lg:gap-y-8'>
        {kickReason ? (
          <>
            <h2 className='row-auto mt-4 text-2xl font-bold lg:text-3xl'>{}</h2>
            <p>You were kicked.</p>
          </>
        ) : (
          <>
            <h2 className='row-auto mt-4 text-2xl font-bold lg:text-3xl'>{invitationState.currentState.selectedInvite?.description}</h2>
            <p>You disconnected. Thanks for playing!</p>
          </>
        )}
      </div>
      <div>
        <Link
          to='https://pavilion.playcast.io'
          className={clsx(buttonVariants(), 'max-w-48 text-wrap py-8 text-center')}
          data-testid='host-your-own-session-button'
        >
          Host Your Own Session on Playcast.io
        </Link>
      </div>
    </div>
  );
};
